<script>
import DialogBody from "../../dialog/components/dialog-body.vue";
import DialogHeader from "../../dialog/components/dialog-header.vue";
import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
import DialogBase from "../../dialog/components/dialog-base.vue";
import API from "../../../API";
import toaster from "../../common/toaster";
import MediaButtons from "../mediapool/components/publish-buttons.vue";
import Loading from "../../common/loading.vue";
import ConfirmDialogBody from "../../dialog/confirm-dialog-body.vue";

export default {
    name: "delete-content-dialog",
    components: {ConfirmDialogBody, Loading, MediaButtons, DialogBase, DialogActionbar, DialogHeader, DialogBody},
    data() {
        return {
            showDialog: false,
            loading: false,
            entries: [],
            updatePublish: 0,
            updateApprove: -1,
        }
    },
    props: {
        type: String,
        title: String,
        privilegePublish: String,
        privilegeApprove: String,
        message: String,
        multiMessage: String,
        url: String
    },
    computed: {
        translations() {
            return {
                yes: Lang.langGet('Yes'),
                no: Lang.langGet('No'),
                delete: Lang.langGet("Delete")
            }
        },
        /** @type {String} */
        actualMessage() {
            return this.multiMode ? this.multiMessage : this.message;
        },
        multiMode() {
            return this.entries.length > 1;
        },
        names() {
            return this.entries.map(entry => entry.name).join(', ');
        }
    },
    methods: {
        handleCancel() {
            this.showDialog = false;
        },
        cycleUpdatePublish: function () {
            this.updatePublish = (parseInt(this.updatePublish) + 1) % 2 || 0;
            localStorage.setItem(`${this.type}-publish-${Laravel.activeProject}`, this.updatePublish);
        },
        cycleUpdateApprove: function () {
            this.updateApprove = (parseInt(this.updateApprove) + 1) % 2 || 0;
            this.updateApprove = this.updateApprove === 1 ? -1 : this.updateApprove;
            localStorage.setItem(`${this.type}-approve-${Laravel.activeProject}`, this.updateApprove);
        },
        async handleConfirm() {
            const warningHasNotBeenShownYet = !localStorage.getItem(`${this.type}-autopublish-confirm-${Laravel.activeProject}`);
            if (this.updatePublish && warningHasNotBeenShownYet) {
                EaseEventBus.fire('showAutopublishWarning', { type: this.type, task: 'Delete' });
            } else {
                await this.delete();
            }
        },
        async delete() {
            this.loading = true;
            const api = new API(this.url);

            const data = {
                id: this.entries.map(entry => entry.id),
                approve: this.updateApprove,
                publish: this.updatePublish
            };

            const result = await api.post(data);

            if (result.errored) {
                toaster.error(Lang.langGet("Failed to delete element!"));
            } else {
                if (this.multiMode) {
                    toaster.success(Lang.langGet("The elements were successfully deleted."));
                } else {
                    toaster.success(Lang.langGet("The element was successfully deleted."));
                }
                EaseEventBus.fire(`on${_.capitalize(this.type)}Deleted`, data.id);
                this.showDialog = false;
            }
        }
    },
    mounted() {
        EaseEventBus.listen('deleteContentDialog', params => {
            if (this.privilegePublish === '1' && this.privilegeApprove === '1') {
                this.updatePublish = parseInt(localStorage.getItem(`${this.type}-publish-${Laravel.activeProject}`) ?? 1);
            }
            if (this.privilegeApprove === '1') {
                this.updateApprove = parseInt(localStorage.getItem(`${this.type}-approve-${Laravel.activeProject}`) ?? 1);
            }
            this.entries = params.entries;
            this.loading = false;
            this.showDialog = true;
        });

        EaseEventBus.listen('updateProceed', (data) => {
            if (data.type === this.type && data.task === 'Delete' && data.proceed) {
                this.delete();
            }
        });
    }
}
</script>

<template>
    <dialog-base
        :maxWidth="480"
        :showDialog="showDialog"
        @close="handleCancel"
    >
        <dialog-header
            :title="title"
            @close="handleCancel"
        />
        <dialog-body>
            <loading :loading="loading" />
            <confirm-dialog-body
                :message="actualMessage"
                :confirmMsg="names"
                showTextIcon
            />
        </dialog-body>
        <div class="d-flex flex-row align-center justify-end pa-4">
            <media-buttons
                :approvePrivilege="privilegeApprove === '1'"
                :publishPrivilege="privilegePublish === '1'"
                :updateApprove="updateApprove"
                :updatePublish="updatePublish"
                :confirmText="translations.delete"
                @cycleUpdatePublish="cycleUpdatePublish"
                @cycleUpdateApprove="cycleUpdateApprove"
                @confirm="handleConfirm"
            />
            <v-btn class="ml-1" @click="handleCancel">
                {{ translations.no }}
            </v-btn>
        </div>
    </dialog-base>
</template>
